<script setup lang="ts">
import { ref, onUnmounted, onMounted, onBeforeMount, nextTick } from 'vue'
import { baseUrl } from '@/core'
import { useRouter } from 'vue-router'
import BulletItems from './BulletItems.vue'
import MenuItems from './MenuItems.vue'
import MenuCaptionItems from './MenuCaptionItems.vue'
import { appBus } from '@/modules/app'

const router = useRouter()

// Define Props ----------------------------------
const props = defineProps<{
  lang: string
}>()

// State -----------------------------------------
const { lang } = props
const bullet = ref<InstanceType<typeof BulletItems>>()
const menu = ref<InstanceType<typeof MenuItems>>()

// Getters ---------------------------------------

// Methods ---------------------------------------
function gotoSermon(id: number) {
  router.push({ path: `/sermon/${id}` })
}

function gotoDiscovery() {
  router.push({ path: '/discovery' })
}

function backgroundMusicInfoHandler(payload: any) {
  console.log('%cbackgroundMusicPlayedHandler', 'color:orange', payload)
  bullet.value?.setActive(payload.track + 1)
  menu.value?.setActive(payload.track + 1)
}

// Events ----------------------------------------
onBeforeMount(() => {
  appBus.events.on('backgroundMusic.info', backgroundMusicInfoHandler)
})

onMounted(() => {
  console.log('onMounted()')
  setTimeout(() => {
    appBus.commands.emit('backgroundMusic.info')
  }, 800)
})

onUnmounted(() => {
  appBus.events.off('backgroundMusic.info', backgroundMusicInfoHandler)
})

function onAnimationend(id: number) {
  console.log('onAnimationend', { id })
  appBus.commands.emit('backgroundMusic.info')
}

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <div :class="['home-content', `lang-${lang}`]">
    <div class="logo-image"></div>
    <div class="logo-text"></div>

    <BulletItems ref="bullet" :lang="lang" />
    <MenuItems ref="menu" :lang="lang" @select="gotoSermon" />
    <MenuCaptionItems :lang="lang" />

    <img
      :class="['menu-discovery', lang]"
      :src="baseUrl(`/images/home/${lang}/menu-discovery.gif`)"
      @click="gotoDiscovery"
    />

    <img :class="['text-tap', lang]" :src="baseUrl(`/images/home/${lang}/text-tap.png`)" />
  </div>
</template>

<style scoped>
/* ------------------------ */
:deep(.blink) {
  opacity: 0;
  animation: blink 2s ease-in-out;
}

/* prettier-ignore */
@keyframes blink {
    0% { opacity: 0; }
    30% { opacity: 1; }
    65% { opacity: 1; }
    100% { opacity: 0; }
}

/* ------------------------ */
.home-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
/* ------------------------ */
.logo-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 646px;
  height: 1080px;
  background: url('/images/home/logo-image.png');
}

.logo-text {
  position: absolute;
  left: 645px;
  top: 0;
  width: 1264px;
  height: 379px;
  background: url('/images/home/th/logo-text.png');
}

/* ------------------------ */
.lang-en .logo-text {
  background: url('/images/home/en/logo-text.png');
}

/* ------------------------ */
.menu-discovery {
  position: absolute;
  left: 987px;
  top: 916px;
  cursor: pointer;
}

.menu-discovery.en {
  position: absolute;
  left: 993px;
  top: 930px;
  cursor: pointer;
}

/* ------------------------ */
.text-tap {
  position: absolute;
  left: 1118px;
  top: 1005px;
}

.text-tap.en {
  top: 1012px;
}
/* ------------------------ */
</style>
